import { Arrow, Close, Content } from '@radix-ui/react-popover'
import { invert } from 'polished'
import styled from 'styled-components'

import { ZIndex } from '../../../constants/ZIndex'
import type { AdvancedColors, ColorShade, Size, Variant } from '../../../themes'
import { getForegroundColor } from '../../../themes/helpers'
import {
  slideDownAndFade,
  slideLeftAndFade,
  slideRightAndFade,
  slideUpAndFade,
} from '../../../utils/styles/keyframes.styles'

const getBackgroundColor = (colors: AdvancedColors, variant: Variant, shade: ColorShade) => {
  if (variant === 'black') return '#262626'
  if (variant === 'white') return variant

  return colors[variant][shade]
}

export const StyledContent = styled(Content)<{ $variant: Variant }>`
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index: ${ZIndex.MAX};
  margin: 0;
  padding: ${props => props.theme.spacingsInsetSquish.small};
  background-color: ${props => getBackgroundColor(props.theme.colors, props.$variant, 'base')};
  border-color: ${props => getBackgroundColor(props.theme.colors, props.$variant, 'dark')};
  border-radius: ${props => props.theme.dimensions.borderRadius};
  color: ${props =>
    props.$variant === 'black' || props.$variant === 'white'
      ? invert(props.$variant)
      : getForegroundColor(props.$variant, props.theme)};

  &[data-state='open'][data-side='top'] {
    animation-name: ${slideDownAndFade};
  }
  &[data-state='open'][data-side='right'] {
    animation-name: ${slideLeftAndFade};
  }
  &[data-state='open'][data-side='bottom'] {
    animation-name: ${slideUpAndFade};
  }
  &[data-state='open'][data-side='left'] {
    animation-name: ${slideRightAndFade};
  }
`

export const StyledArrow = styled(Arrow)<{ $variant: Variant }>`
  fill: ${props => getBackgroundColor(props.theme.colors, props.$variant, 'base')};
`

export const StyledClose = styled(Close)<{ $spacing: Size }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.neutral.base};
  position: absolute;
  top: ${props => props.theme.spacings[props.$spacing]};
  right: ${props => props.theme.spacings[props.$spacing]};
`
